import { Stack } from 'expo-router';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useStoreRequired } from 'state/store/hooks/use-store-required';
import { primitive } from 'styles/constants/primitives';

export const unstable_settings = {
  initialRouteName: 'index',
};

export default function OffersLayout() {
  useStoreRequired(Boolean(useFlag(LaunchDarklyFlag.FORCE_RESTAURANT_SELECTION_FOR_REWARDS)));

  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: primitive.bk.$mayoEggWhite },
      }}
    >
      <Stack.Screen name="index" />
      {/* NOTE: modals are in (modals) */}
    </Stack>
  );
}
